import React from 'react';
import PropTypes from 'prop-types';

import { mergeClasses } from '@utils';

export default function Logo({ className }) {
  return (
    <svg
      viewBox="0 0 96 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={mergeClasses('', className)}
    >
      <g>
        <path d="M0 15.1V0H7.6V19.1L0 15.1Z" fill="#0CD428" />
        <path
          fill="#0CD428"
          d="M8.7 19.7L14 14.6V0H21.6V17.2L15.4 23.1L8.7 19.7Z"
        />
        <path
          fill="black"
          d="M31 12.6V7.2H33.5V12.4C33.5 13.9 34.2 14.7 35.5 14.7C36.8 14.7 37.5 13.9 37.5 12.4V7.2H40V12.6C40 15.6 38.2 17.1 35.5 17.1C32.8 17.1 31 15.6 31 12.6ZM41.1 7.2H43.6V8.3C44.2 7.4 45.2 6.9 46.5 6.9C48.7 6.9 50.1 8.6 50.1 11.1V16.8H47.6V11.6C47.6 10.1 46.9 9.3 45.7 9.3C44.2 9.3 43.6 10.3 43.6 12V16.8H41.1V7.2ZM50.9 4.5C50.9 3.7 51.6 3 52.4 3C53.3 3 53.9 3.7 53.9 4.5C53.9 5.3 53.2 6 52.4 6C51.5 6 50.9 5.3 50.9 4.5ZM51.2 7.2H53.7V16.9H51.2V7.2ZM54.4 15.4L56 13.8C56.6 14.4 57.3 14.8 58.3 14.8C59 14.8 59.5 14.5 59.5 13.9C59.5 13.3 59 13.1 57.9 12.8C56.5 12.4 54.7 11.8 54.7 9.7C54.7 7.8 56.5 6.7 58.2 6.7C59.8 6.7 60.9 7.3 61.8 8.2L60.2 9.8C59.6 9.3 59 9 58.3 9C57.7 9 57.2 9.3 57.2 9.8C57.2 10.4 57.7 10.6 59 10.9C60.6 11.3 62 12.1 62 13.9C62 16 60.3 17 58.4 17C56.7 17.1 55.3 16.5 54.4 15.4ZM62.9 7.2H65.4V8.3C66.1 7.4 67.2 6.9 68.6 6.9C71.4 6.9 73.1 9.1 73.1 12C73.1 14.9 71 17.1 68.5 17.1C67.1 17.1 66.1 16.6 65.4 15.9V20.7H62.9V7.2ZM70.5 12C70.5 10.5 69.5 9.3 67.9 9.3C66.3 9.3 65.3 10.5 65.3 12C65.3 13.5 66.3 14.7 67.9 14.7C69.5 14.7 70.5 13.5 70.5 12ZM73.7 12C73.7 9.1 75.8 6.9 78.8 6.9C81.8 6.9 83.9 9.1 83.9 12C83.9 14.9 81.8 17.1 78.8 17.1C75.8 17.1 73.7 14.9 73.7 12ZM81.4 12C81.4 10.5 80.4 9.3 78.8 9.3C77.2 9.3 76.2 10.5 76.2 12C76.2 13.5 77.2 14.7 78.8 14.7C80.4 14.7 81.4 13.5 81.4 12ZM84.6 7.2H87.1V8.9C87.5 7.6 88.4 7.2 89.3 7.2H89.6V9.6H89.2C87.6 9.6 87 10.5 87 12.5V16.8H84.5V7.2H84.6ZM91.4 14V9.5H90.3V7.2H91.4V5.8L93.8 4.5V7.2H95.8V9.6H93.8V13.5C93.8 14.4 94 14.5 95 14.5H95.8V16.9H94.4C92.2 16.8 91.4 15.9 91.4 14Z"
        />
      </g>
    </svg>
  );
}

Logo.propTypes = {
  className: PropTypes.string
};

Logo.defaultProps = {
  className: ''
};
